import {
  organizationQueryKey,
  useMutationDeleteOrganization,
} from "@apis:organization/organization";
import { ConfirmationDialog } from "@components:ConfirmationDialog";
import { useInvalidateQueries } from "@hooks:useInvalidateQueries";
import { useToasterStoreActions } from "@stores:global";

interface OrganizationDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  organizationId: string;
}

export const OrganizationDeleteModal = ({
  isOpen,
  onClose,
  organizationId,
}: OrganizationDeleteModalProps) => {
  const invalidateQueries = useInvalidateQueries();
  const toastActions = useToasterStoreActions();
  const mutationDeleteOrganization = useMutationDeleteOrganization({
    onSuccess: async () => {
      toastActions.setToaster({
        open: true,
        message: "Organization deleted",
        variant: "success",
      });
      await invalidateQueries.run([
        {
          queryKey: organizationQueryKey.getAll.queryKey,
        },
      ]);
      onClose();
    },
    onError: () => {
      toastActions.setToaster({
        open: true,
        message: "Failed to delete organization",
        variant: "error",
      });
    },
  });

  const handleDelete = async () => {
    await mutationDeleteOrganization.mutateAsync({ id: organizationId });
  };

  return (
    <ConfirmationDialog
      open={isOpen}
      onClose={() => onClose()}
      title={"Delete Organization"}
      description="Are you sure you want to delete this organization?"
      actionControls={{
        secondary: {
          label: "Cancel",
          onClick: () => {
            onClose();
          },
          sx: {
            width: "5rem",
          },
        },
        primary: {
          sx: {
            width: "5rem",
            backgroundColor: (theme) => theme.palette.error.main,
          },
          label: "Delete",
          onClick: async () => {
            await handleDelete();
          },
          disabled: !organizationId,
        },
      }}
    />
  );
};
